module.exports = __webpack_public_path__ + "static/img/desktop_bkg.b74c5a8d.png";